import React, { Component } from 'react'
import { slide as Menu } from 'react-burger-menu'
import Modal from 'react-modal'

import Link from 'gatsby-link'
import styles from './Navigation.module.css'
import Instagram from './icons/Instagram'
import Twitter from './icons/Twitter'
import Facebook from './icons/Facebook'
import Soundcloud from './icons/Soundcloud'
import Spotify from './icons/Spotify'
import AppleMusic from './icons/AppleMusic'
import Subscribe from './Subscribe/Subscribe'

class Navigation extends Component {
  constructor() {
    super()
    this.state = {
      menuOpen: false,
      modalIsOpen: false,
    }
  }

  openModal = () => {
    this.setState({ modalIsOpen: true })
  }

  closeModal = () => {
    this.setState({ modalIsOpen: false })
  }

  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen })
  }

  closeMenu() {
    this.setState({ menuOpen: false })
  }

  handleOpenEightRoomsDropdown = () => {
    this.setState({
      eightRoomsDropdownOpen: !this.state.eightRoomsDropdownOpen,
    })
  }

  joinOnClick = () => {
    this.openModal()
    this.closeMenu()
  }

  renderNav() {
    return (
      <ul>
        <li>
          <Link to="/" onClick={() => this.closeMenu()}>
            LYVES
          </Link>
        </li>
        <li>
          <Link to="/8-rooms" onClick={() => this.closeMenu()}>
            8 Rooms
          </Link>
        </li>
        {/* <li>Words</li> */}
        <li>
          <Link to="/biography" onClick={() => this.closeMenu()}>
            Biography
          </Link>
        </li>
        <li>
          <a href="https://tickets.lnk.to/Lyves" target="_blank">
            Live
          </a>
        </li>
        <li>
          <Link to="/contact" onClick={() => this.closeMenu()}>
            Contact
          </Link>
        </li>
        <li onClick={() => this.joinOnClick()}>Join</li>
        <li className={styles.socialIcon}>
          <a
            target="_blank"
            onClick={() => this.closeMenu()}
            href="https://www.instagram.com/lyvesmusic"
          >
            <Instagram />
          </a>
        </li>
        <li className={styles.socialIcon}>
          <a
            target="_blank"
            onClick={() => this.closeMenu()}
            href="https://twitter.com/lyvesmusic"
          >
            <Twitter />
          </a>
        </li>
        <li className={styles.socialIcon}>
          <a
            target="_blank"
            onClick={() => this.closeMenu()}
            href="https://www.facebook.com/lyvesmusic/"
          >
            <Facebook />
          </a>
        </li>
        <li className={styles.socialIcon}>
          <a
            target="_blank"
            onClick={() => this.closeMenu()}
            href="https://soundcloud.com/lyvesmusic"
          >
            <Soundcloud />
          </a>
        </li>
        <li className={styles.socialIcon}>
          <a
            onClick={() => this.closeMenu()}
            target="_blank"
            href="https://open.spotify.com/artist/0q31MBlCXGIFG6gl11Yn0t?si=JZubnRtxQVSxtNeaOQWE_A"
          >
            <Spotify />
          </a>
        </li>
        <li className={styles.socialIcon}>
          <a
            onClick={() => this.closeMenu()}
            target="_blank"
            href="https://itunes.apple.com/gb/artist/lyves/1013015933"
          >
            <AppleMusic />
          </a>
        </li>
      </ul>
    )
  }

  render() {
    const nav = this.renderNav()
    return (
      <div>
        <div className={styles.Navigation}>{nav}</div>
        <Menu
          right
          isOpen={this.state.menuOpen}
          onStateChange={state => this.handleStateChange(state)}
          burgerButtonClassName={styles.menuButton}
          crossButtonClassName={styles.crossButton}
          menuClassName={styles.mobileMenuOpen}
          className={styles.mobileMenu}
        >
          {nav}
        </Menu>

        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Example Modal"
          className={styles.modal}
          overlayClassName={styles.overlay}
        >
          <Subscribe />
        </Modal>
      </div>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js